(() => {
  'use strict';

  const money = (cents, currency = window.Shopify?.currency?.active || 'USD') => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format((cents || 0) / 100); }
    catch { return `$${((cents || 0) / 100).toFixed(2)}`; }
  };

  const lockBody = (locked) => document.body.classList.toggle('is-locked', locked);

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuOpen = document.querySelector('[data-menu-open]');
  const closeMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.hidden = true;
    menuOpen?.setAttribute('aria-expanded', 'false');
    lockBody(false);
  };
  menuOpen?.addEventListener('click', () => {
    mobileMenu.hidden = false;
    menuOpen.setAttribute('aria-expanded', 'true');
    lockBody(true);
    mobileMenu.querySelector('.mobile-menu__panel')?.focus?.();
  });
  document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', closeMenu));

  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerPanel = drawer?.querySelector('.cart-drawer__panel');
  const drawerItems = drawer?.querySelector('[data-cart-items]');
  const drawerFooter = drawer?.querySelector('[data-cart-footer]');

  const updateCartCount = (count) => document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count; });

  const renderCart = (cart) => {
    updateCartCount(cart.item_count);
    if (!drawerItems || !drawerFooter) return;
    if (!cart.items.length) {
      drawerItems.innerHTML = '<p class="cart-drawer__empty">Your bag is waiting for something memorable.</p>';
      drawerFooter.hidden = true;
      return;
    }
    drawerItems.innerHTML = cart.items.map((item, index) => {
      const image = item.image ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g, '&quot;')}" loading="lazy">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${item.variant_title}</p>` : '';
      return `<article class="cart-drawer-item">
        <a class="cart-drawer-item__image" href="${item.url}">${image}</a>
        <div class="cart-drawer-item__details"><h3><a href="${item.url}">${item.product_title}</a></h3>${variant}<p>${money(item.final_line_price)}</p>
          <div class="cart-drawer-item__controls"><button type="button" data-cart-change="${index + 1}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${index + 1}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button><button class="cart-drawer-item__remove" type="button" data-cart-change="${index + 1}" data-qty="0">Remove</button></div>
        </div>
      </article>`;
    }).join('');
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    drawerFooter.hidden = false;
    drawerItems.querySelectorAll('[data-cart-change]').forEach((button) => {
      button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(button.dataset.cartChange), quantity: Number(button.dataset.qty) }) });
          if (!response.ok) throw new Error('Unable to update cart');
          renderCart(await response.json());
        } catch (error) { announce(error.message); }
      });
    });
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to open the cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const openCart = async () => {
    if (!drawer) { window.location.href = '/cart'; return; }
    drawer.hidden = false;
    lockBody(true);
    try { await fetchCart(); } catch (error) { announce(error.message); }
    drawerPanel?.focus();
  };
  const closeCart = () => { if (!drawer) return; drawer.hidden = true; lockBody(false); };
  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));

  const announce = (message) => {
    const region = document.getElementById('CartLiveRegion');
    if (region) region.textContent = message;
  };

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const hiddenInput = root.querySelector('[data-variant-input]');
    const addButton = root.querySelector('[data-add-button]');
    const addButtonText = root.querySelector('[data-add-button-text]');
    const price = root.querySelector('[data-product-price]');
    if (select) {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (hiddenInput) hiddenInput.value = option.value;
        if (price) price.textContent = option.dataset.price;
        const available = option.dataset.available === 'true';
        if (addButton) addButton.disabled = !available;
        if (addButtonText) addButtonText.textContent = available ? 'Add to the Bespoke Bag' : 'Sold out';
        const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
      });
    }

    root.querySelectorAll('[data-quantity-control]').forEach((control) => {
      const input = control.querySelector('input');
      control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1); });
      control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { input.value = Number(input.value || 1) + 1; });
    });

    root.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('.product-thumb').forEach((thumb) => thumb.classList.remove('is-active'));
      root.querySelectorAll('.product-media').forEach((media) => media.classList.toggle('is-hidden', media.dataset.mediaId !== button.dataset.mediaTarget));
      button.classList.add('is-active');
    }));
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[data-add-button]');
      const label = form.querySelector('[data-add-button-text]');
      const message = form.querySelector('[data-product-message]');
      button.disabled = true;
      const original = label?.textContent;
      if (label) label.textContent = 'Adding…';
      if (message) message.textContent = '';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || 'This item could not be added.');
        if (message) message.textContent = 'Added with care.';
        announce(`${payload.product_title || 'Item'} added to cart`);
        await openCart();
      } catch (error) {
        if (message) message.textContent = error.message;
        announce(error.message);
      } finally {
        button.disabled = false;
        if (label) label.textContent = original;
      }
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => select.addEventListener('change', () => select.form.submit()));

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeCart();
    if (mobileMenu && !mobileMenu.hidden) closeMenu();
  });
})();
